import { Component } from '@angular/core';

@Component({
    selector: 'app-background',
    imports: [],
    templateUrl: './background.component.html',
    styleUrl: './background.component.scss'
})
export class BackgroundComponent {

}
